var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn-more-artwork"},[_c('a',{attrs:{"href":("/artwork/" + _vm.slug),"data-wt_params":"WT.ihtml=Learn More","aria-label":("Learn More about " + _vm.name)}},[_vm._v("\n    Learn More\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }